export default __webpack_public_path__ + "static/media/sky.3c576859.svg";